import { post, receive, start } from "./.fable/fable-library.3.1.16/MailboxProcessor.js";
import { singleton } from "./.fable/fable-library.3.1.16/AsyncBuilder.js";
import { compareTo, addMilliseconds, now as now_1 } from "./.fable/fable-library.3.1.16/Date.js";
import { startImmediate, createCancellationToken, cancel as cancel_2, sleep } from "./.fable/fable-library.3.1.16/Async.js";

const throttleAgent = start((inbox) => {
    const loop = (tupledArg) => {
        const last = tupledArg[0];
        const cancel = tupledArg[1];
        return singleton.Delay(() => singleton.Bind(receive(inbox), (_arg1) => {
            let copyOfStruct, cancel_1;
            const ms = _arg1[0] | 0;
            const fn = _arg1[1];
            const now = now_1();
            const runLater = singleton.Delay(() => singleton.Bind(sleep(ms), () => {
                fn();
                return singleton.Zero();
            }));
            return singleton.ReturnFrom(loop(((copyOfStruct = addMilliseconds(last, ms), compareTo(copyOfStruct, now)) < 0) ? (fn(), [now, cancel]) : (cancel_2(cancel), (cancel_1 = createCancellationToken(), (startImmediate(runLater, cancel_1), [last, cancel_1])))));
        }));
    };
    return loop([now_1(), createCancellationToken()]);
});

export function throttle(ms, fn) {
    post(throttleAgent, [ms, fn]);
}

